export default [
    //钢琴
    {
        id: 1,
        category:'piano',
        subtitle: '跨界钢琴',//类别
        title: 'DGC1 ENST PWH',//型号
        artist: '',//没有，为空
        detail: [
            { img: '1-1.jpg' },
            { p: 'ENSPIRE  ST潜力无穷，它具有全面的录音和播放功能以及拥有专利的Yamaha SILENT  Piano™静音系统及DSP伺服驱动系统，适用于对自动演奏钢琴有更多追求的用户。DGC1 ENST基于三角钢琴GC1。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/1668'
    },
    {
        id: 2,
        category:'piano',
        subtitle: '跨界钢琴',
        title: 'DC7X ENPRO',
        artist: '',
        detail: [
            { img: '1-2.jpg' },
            { p: 'ENSPIRE  PRO是雅马哈旗舰型自动演奏钢琴，它可以在高品质的原声钢琴中进行高解析度录音和播放，非常适合精益求精的用户使用。DC7X ENPRO基于三角钢琴C7X。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/1666'
    },
    {
        id: 3,
        category:'piano',
        subtitle: '贝森朵夫三角钢琴',
        title: '280VC',
        artist: '',
        detail: [
            { img: '1-3.jpg' },
            { p: '280VC型是一款拥有新设计的贝森朵夫音乐会三角钢琴。在键盘和击弦机上着重采用了新兴技术，使键盘的长度由低音到高音渐变，从而实现了弦槌板重量分布的优化。击弦机和键盘的完美融合带来了出色的控制力。<br />诞生于21世纪，蕴藏无限可能的280VC型，无论是与交响乐团合奏，还是对于追求多彩音色的室内音乐，是演奏者的理想搭档。' }
        ],
        link:'https://boesendorfer.cn/pianos/detail?id=10'
    },
    {
        id: 4,
        category:'piano',
        subtitle: '三角钢琴',
        title: 'CFX',
        artist: '',
        detail: [
            { img: '1-4.jpg' },
            { p: '殿堂级音乐会三角钢琴CF系列旗舰产品CFX，拥有着卓越的声音，其穿透力可使声音响彻在音乐厅的每一处角落。既是雅马哈钢琴的顶点，又是新的原点。<br />历经19年的潜心研制与开发，融入了雅马哈先进的制造工艺和世界众多艺术家对钢琴的需求和期望，使得这台全尺寸音乐会三角钢琴真正成为“苛求完美，再塑卓越”的实例。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/14'
    },
    {
        id: 5,
        category:'piano',
        subtitle: '跨界钢琴',
        title: 'NU1X',
        artist: '',
        detail: [
            { img: '1-5.jpg' },
            { p: '结合传统钢琴的物理击弦与雅马哈科技的二次创新。外表精致简洁，体验不容小觑。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/1761'
    },
    {
        id: 6,
        category:'piano',
        subtitle: '跨界钢琴',
        title: 'DC3X ENPRO',
        artist: '',
        detail: [
            { img: '1-6.jpg' },
            { p: 'ENSPIRE  PRO是雅马哈旗舰型自动演奏钢琴，它可以在高品质的原声钢琴中进行高解析度录音和播放，非常适合精益求精的用户使用。DC3X ENPRO基于三角钢琴C3X。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/1663'
    },
    {
        id: 7,
        category:'piano',
        subtitle: '跨界钢琴',
        title: 'DCFX ENPRO',
        artist: '',
        detail: [
            { img: '1-7.jpg' },
            { p: 'ENSPIRE  PRO是雅马哈旗舰型自动演奏钢琴，它可以在高品质的原声钢琴中进行高解析度录音和播放，非常适合精益求精的用户使用。DCFX ENPRO基于三角钢琴CFX。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/1751'
    },
    {
        id: 8,
        category:'piano',
        subtitle: '贝森朵夫三角钢琴',
        title: '280VC DISKLAVIER EDITION',
        artist: '',
        detail: [
            { img: '1-8.jpg' },
            { p: '采用了由雅马哈最新研发的Disklavier Enspire回放技术。贝森朵夫Disklavier型钢琴内置一千多首不同风格、不同题材的曲目。演奏者不仅能倾听享受海量典藏琴曲，更能立刻回放自己的现场演奏乐曲。 无论是轻柔的触键，激烈的切分，脚踏的变化，还有艺术的表达，所有的细节的动态的措辞，踏板和艺术的发音，一切的细节都会精确地记录，保存在原创乐曲库中。' }
        ],
        link:''
    },
    {
        id: 9,
        category:'piano',
        subtitle: '跨界钢琴',
        title: 'U1TA2',
        artist: '',
        detail: [
            { img: '1-9.jpg' },
            { p: '原声与电音的融合。<br />通过加振模式，可以将原声钢琴的声音和电音进行混响，表现出古典风格、爵士风格、流行风格等不同的演奏形式，拓展了演奏表现的可能性。<br />随时随地、随心所欲尽享原声音乐带来的美妙人生。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/2247'
    },
    {
        id: 11,
        category:'piano',
        subtitle: '跨界钢琴',
        title: 'N3X',
        artist: '',
        detail: [
            { img: '1-11.jpg' },
            { p: '全新的数字技术与传统原声钢琴的无缝融合，精确地还原了三角钢琴的触感、音色甚至是琴体的共振。AvantGrand  N3X通过其出色的音 乐表现力，征服了世界上具备丰富鉴赏力的钢琴家。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/2240'
    },
    {
        id: 12,
        category:'piano',
        subtitle: '跨界钢琴',
        title: 'N1X',
        artist: '',
        detail: [
            { img: '1-12.jpg' },
            { p: '搭载三角钢琴击弦机的N1X忠实还原了原声三角钢琴的手感及音色。时尚、简约的设计将美观与实用性合二为一。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/2241'
    },
    {
        id: 13,
        category:'piano',
        subtitle: '三角钢琴',
        title: 'S5X',
        artist: '',
        detail: [
            { img: '1-13.jpg' },
            { p: '媲美音乐会级三角钢琴的性能，丰富华丽的音色能够满足演奏家对声音美感的需求。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/1753'
    },
    {
        id: 14,
        category:'piano',
        subtitle: '三角钢琴',
        title: 'CF4',
        artist: '',
        detail: [
            { img: '1-14.jpg' },
            { p: '明亮又丰富的音色，纤细中蕴含着力量。正是新型音乐会三角钢琴CF4所奏出的美妙琴音。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/16'
    },
    {
        id: 15,
        category:'piano',
        subtitle: '三角钢琴',
        title: 'CF6',
        artist: '',
        detail: [
            { img: '1-15.jpg' },
            { p: 'CF6继承了CFX所有的遗传因子。在中等规模的音乐厅中，无论是音乐会或是中型交响乐团，CF6都能充分发挥其才华。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/15'
    },
    {
        id: 16,
        category:'piano',
        subtitle: '贝森朵夫三角钢琴',
        title: 'Dragonfly PWH',
        artist: '',
        detail: [
            { img: '1-16.jpg' },
            { p: '采用多种木材来设计饰物，花朵和动物图案的造型素来就是奢侈豪华的标志。这一点从传统家具与钢琴大量采用昂贵的镶嵌装饰均可见一斑。<br/>此系列的钢琴正是对华丽的花园，皇家的奢华壁画以及如魔法般将大自然记录在一瞬间的颂扬。<br/>此系列三角钢琴为限量版，尺寸为200，共计发售18台，其中白色蜻蜓型为全球唯一一台，每台均有其单独的身份铭牌。' }
        ],
        link:'https://boesendorfer.cn/pianos/detail?id=17'
    },

    //电子键盘
    {
        id: 1,
        category:'ekb',
        subtitle: '数码钢琴',
        title: 'CVP-809GP',
        artist: '',
        detail: [
            { img: '2-1.jpg' },
            { p: '下键即可感受到其的与众不同<br/>真实的触键感受及灵敏的力度反馈，加之高品质的音乐会三角钢琴音色，<br/>Clavinova CVP-809为您提供更强的音乐表现力和动态范围，开启当今数码钢琴全新标准。<br/>•CFX及贝森朵夫帝王钢琴音源采样<br/>•1,605种音色+58鼓组/SFX效果+480种XG音色，其中含17种虚拟建模技术音色，36种超清晰音色2代音色，301种超清晰音色<br/>•GrandTouch键盘，合成象牙白键表面，实木白键，合成乌木黑键<br/>•675种预置伴奏型<br/>•9.0英寸800*480像素TFT彩色触摸显示屏' }
        ],
        link:''
    },
    {
        id: 2,
        category:'ekb',
        subtitle: '数码钢琴',
        title: 'CVP-809B/PE',
        artist: '',
        detail: [
            { img: '2-2.jpg' },
            { p: '下键即可感受到其的与众不同<br/>真实的触键感受及灵敏的力度反馈，加之高品质的音乐会三角钢琴音色，<br/>Clavinova CVP-809为您提供更强的音乐表现力和动态范围，开启当今数码钢琴全新标准。<br/>•CFX及贝森朵夫帝王钢琴音源采样<br/>•1,605种音色+58鼓组/SFX效果+480种XG音色，其中含17种虚拟建模技术音色，36种超清晰音色2代音色，301种超清晰音色<br/>•GrandTouch键盘，合成象牙白键表面，实木白键，合成乌木黑键<br/>•675种预置伴奏型<br/>•9.0英寸800*480像素TFT彩色触摸显示屏' }
        ],
        link:''
    },
    {
        id: 3,
        category:'ekb',
        subtitle: '数码钢琴',
        title: 'CLP-695GPWH',
        artist: '',
        detail: [
            { img: '2-3.jpg' },
            { p: '结合GrandTouch键盘及音响系统，提供您卓越的三角钢琴体验。<br/>•CFX及贝森朵夫帝王钢琴音源采样<br/>•CFX头模双耳采样<br/>•全新设计的VRM虚拟共振建模技术<br/>•256最大发声数<br/>•49种音色+480种XG音色 +GM2/GS音色（用于乐曲播放）<br/>•GrandTouch键盘，合成象牙白键表面，实木白键，合成乌木黑键<br/>•触后装置<br/>•配重铅块<br/>•88键线性分级键盘<br/>•三角钢琴响应制音踏板<br/>•128 x 64 full dot LCD显示屏幕<br/>•双音色/分割音色<br/>•数码效果（混响/合唱/明亮/效果）<br/>•19种音色示范乐曲＋50首钢琴乐曲（随琴附赠乐谱）＋303首练习曲<br/>•16音轨录音<br/>•USB音频录音（播放/录音格式：WAV）<br/>•USB TO HOST 及 USB TO DEVICE<br/>•双耳机插孔<br/>•(50W + 50W + 50W)x 2扬声器<br/>•(16 cm + 8 cm + 2.5 cm (顶部)) x 2 扬声器系统<br/>•云杉木材质锥形单元扬声器<br/>•声学优化器（Acoustic Optimizer）<br/>•智能声学控制（Intelligent Acoustic Control, IAC）<br/>•立体声优化' }
        ],
        link:'https://www.yamaha.com.cn/products/show/2208'
    },
    {
        id: 4,
        category:'ekb',
        subtitle: '数码钢琴',
        title: 'CLP-685PE',
        artist: '',
        detail: [
            { img: '2-4.jpg' },
            { p: '结合GrandTouch键盘及音响系统，提供您卓越的三角钢琴体验。<br/>•CFX及贝森朵夫帝王钢琴音源采样<br/>•CFX头模双耳采样<br/>•全新设计的VRM虚拟共振建模技术<br/>•平滑释音<br/>•离键采样<br/>•琴弦共鸣<br/>•制音共鸣<br/>•256最大发声数<br/>•49种音色+480种XG音色 +GM2/GS音色（用于乐曲播放）<br/>•GrandTouch键盘，合成象牙白键表面，实木白键，合成乌木黑键，88键线性分级键盘<br/>•触后装置<br/>•配重铅块<br/>•三角钢琴响应制音踏板<br/>•128 x 64 full dot LCD显示屏幕<br/>•双音色/分割音色<br/>•数码效果（混响/合唱/明亮/效果）<br/>•19种音色示范乐曲＋50首钢琴乐曲（随琴附赠乐谱）＋303首练习曲<br/>•16音轨录音<br/>•USB音频录音（播放/录音格式：WAV）<br/>•USB TO HOST 及 USB TO DEVICE<br/>•双耳机插孔<br/>•(50W + 50W + 50W)x 2扬声器<br/>•(16 cm + 8 cm + 2.5 cm (顶部)) x 2 扬声器系统<br/>•云杉木材质锥形单元扬声器<br/>•声学优化器（Acoustic Optimizer）<br/>•智能声学控制（Intelligent Acoustic Control, IAC）<br/>•立体声优化' }
        ],
        link:'https://www.yamaha.com.cn/products/show/1704'
    },
    {
        id: 5,
        category:'ekb',
        subtitle: '数码钢琴',
        title: 'CSP-170B',
        artist: '',
        detail: [
            { img: '2-5.jpg' },
            { p: '雅马哈Clavinova数码钢琴CSP系列是融入了全新科技的数码钢琴。即使是从未学习过钢琴或完全不懂五线谱的人，也可以马上享受弹琴的乐趣。<br/>专属的Clavinova "Smart Pianist"应用程序可以分析您想要弹奏的曲子，然后变成钢琴伴奏乐谱。只需要跟随键盘上的下落式引导灯弹奏就行了！' }
        ],
        link:'https://www.yamaha.com.cn/products/show/1723'
    },
    {
        id: 6,
        category:'ekb',
        subtitle: '电子琴',
        title: 'GENOS',
        artist: '',
        detail: [
            { img: '2-6.jpg' },
            { p: '无论在声音、设计和用户体验方面，Genos都成为数码音乐工作站全新的标杆。无论在录音室还是舞台，Genos都将启发并提升您的音乐创作与表演。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/1759'
    },
    {
        id: 7,
        category:'ekb',
        subtitle: '电子琴',
        title: 'PSR-SX900',
        artist: '',
        detail: [
            { img: '2-7.jpg' },
            { p: '•1337种音色，包括252种超清晰音色和24种管风琴音色，56个鼓组/SFX套件<br/>•525种伴奏，包括463种专业、46种即兴、10种DJ和6种自由弹奏<br/>•预安装的扩充内容<br/>•实际失真和实际残响，搭配直觉式效果接口<br/>•1GB内存，供扩充数据使用<br/>•4GB内建内存<br/>•MIDI乐曲档案容量：每个档案 3MB<br/>•十字游戏杆、FSB键盘，展现更具爆发力的现场表演<br/>•7吋彩色触控屏幕和可指定功能，让您操作更直觉快速<br/>•和弦循环功能<br/>•麦克风/吉他输入，演唱或与其他表演者合作更便利<br/>•播放一览表和面板设定，让您快速且轻松进行设定<br/>•人声和声与人声合成器功能<br/>•音讯录制(WAV/MP3)<br/>•使用Yamaha Expansion Manager扩充音色和伴奏<br/>•2个USB TO DEVICE端子<br/>•外接显示器功能<br/>•蓝芽音讯* 将根据您所在国家可能不提供该功能' }
        ],
        link:''
    },
    {
        id: 8,
        category:'ekb',
        subtitle: '电子琴',
        title: 'PSR-SX700',
        artist: '',
        detail: [
            { img: '2-8.jpg' },
            { p: '•986种音色，包括131种超清晰音色和24种管風琴音色，41個鼓組/SFX套件 <br/>•400种伴奏，包括353种专业、34种即兴、10种DJ和3种自由弹奏<br/>•预先安装的扩种内容<br/>•400MB记忆体，供扩充資料使用 <br/>•1GB內建记忆体<br/>•MIDI乐曲档案容量：每个档案3MB<br/>•十字摇杆、FSB 键盘，展現更具爆发力的现场表演<br/>•7寸彩色触控屏幕和可指定功能，让您操作更直接快速<br/>•麥克風/吉他輸入，演唱或與其他表演者合作更便利<br/>•播放一览表和面板设定，让您快速且轻松进行设定<br/>•音频录制(WAV/MP3)<br/>•使用Yamaha Expansion Manager扩充音色和伴奏' }
        ],
        link:''
    },
    {
        id: 10,
        category:'ekb',
        subtitle: '电子琴',
        title: 'SHS-500B',
        artist: '',
        detail: [
            { img: '2-10.jpg' },
            { p: 'SHS-500搭载了30种不同的乐器音色。从合成器到架子鼓，SHS-500都可以让你纵情演奏任何一种音乐风格。富有表现力的迷你37键盘提供了优异的触感与精准快速的响应。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/2249'
    },
    {
        id: 11,
        category:'ekb',
        subtitle: '电子琴',
        title: 'SHS-500RD',
        artist: '',
        detail: [
            { img: '2-11.jpg' },
            { p: 'SHS-500搭载了30种不同的乐器音色。从合成器到架子鼓，SHS-500都可以让你纵情演奏任何一种音乐风格。富有表现力的迷你37键盘提供了优异的触感与精准快速的响应。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/2249'
    },
    {
        id: 12,
        category:'ekb',
        subtitle: '电子琴',
        title: 'PSR-E360DW',
        artist: '',
        detail: [
            { img: '2-12.jpg' },
            { p: '•400 种优质音效，130 种自动伴奏风格 <br/>•112 首曲目，轻松弹奏的曲谱（可通过网络下载） <br/>•九阶段教学功能 (Yamaha Education Suite) <br/>•录音功能 <br/>•AUX IN 插孔，可连接外部音源 <br/>•总EQ/超宽立体声<br/>•二重奏模式 <br/>•小巧且可携式设计' }
        ],
        link:'https://www.yamaha.com.cn/products/show/2300'
    },
    {
        id: 13,
        category:'ekb',
        subtitle: '电子琴',
        title: 'PSR-E360MA',
        artist: '',
        detail: [
            { img: '2-13.jpg' },
            { p: '•400 种优质音效，130 种自动伴奏风格 <br/>•112 首曲目，轻松弹奏的曲谱（可通过网络下载） <br/>•九阶段教学功能 (Yamaha Education Suite) <br/>•录音功能 <br/>•AUX IN 插孔，可连接外部音源 <br/>•总EQ/超宽立体声<br/>•二重奏模式 <br/>•小巧且可携式设计' }
        ],
        link:'https://www.yamaha.com.cn/products/show/2300'
    },
    {
        id: 14,
        category:'ekb',
        subtitle: '电子琴',
        title: 'KB-309',
        artist: '',
        detail: [
            { img: '2-14.jpg' },
            { p: '•黑色机身，61键风琴键盘 <br/>•761种高品质音色（包括45个中国民乐音色/民族乐鼓组+10个琶音音色 +466种XGlite音色） <br/>•270种高品质伴奏型（包括35种中国风格伴奏） <br/>•直触式操作中文印刷面板 <br/>•中文功能显示屏 <br/>•USB音频录音/播放 <br/>•MIDI格式多轨录音 <br/>•8x4注册记忆存储，可保存至USB <br/>•6W+6W高品质扬声器 <br/>•48复音数 <br/>•快速采样功能' }
        ],
        link:'https://www.yamaha.com.cn/products/show/2276'
    },
    {
        id: 15,
        category:'ekb',
        subtitle: '电子琴',
        title: 'KB-308',
        artist: '',
        detail: [
            { img: '2-15.jpg' },
            { p: '•银色机身，61键风琴键盘<br/>•761种高品质音色（包括45个中国民乐音色/民族乐鼓组/+10个琶音音色 +466种XGlite音色）<br/>•270种高品质伴奏型（包括35种中国风格伴奏）<br/>•直触式操作中文印刷面板<br/>•中文功能显示屏<br/>•USB音频录音/播放<br/>•MIDI格式多轨录音<br/>•8x4注册记忆存储，可保存至USB<br/>•6W+6W高品质扬声器<br/>•48复音数<br/>•快速采样功能' }
        ],
        link:'https://www.yamaha.com.cn/products/show/2275'
    },
    {
        id: 16,
        category:'ekb',
        subtitle: '电子琴',
        title: 'PSS-F30',
        artist: '',
        detail: [
            { img: '2-16.jpg' },
            { p: '•120种音色<br/>•114种节奏型<br/>•智能和弦<br/>•30首乐曲<br/>•乐谱<br/>•键盘<br/>•功能按钮' }
        ],
        link:''
    },
    {
        id: 17,
        category:'ekb',
        subtitle: '电子琴',
        title: 'PSS-E30',
        artist: '',
        detail: [
            { img: '2-17.jpg' },
            { p: '包含交通工具、动物及各类有趣的音色，激发孩子的兴趣。小测验模式使孩子在游戏的乐趣中自然的学习音乐基础知识，让孩子猜听到的音色效果及正确的听音。内置著名乐曲值得孩子终生学习。<br/>•49种音色<br/>•74种SFX 音色<br/>•小测验模式<br/>•30首乐曲<br/>•乐谱<br/>•28种节奏型<br/>•Mini-key  Mini键盘' }
        ],
        link:''
    },
    {
        id: 18,
        category:'ekb',
        subtitle: '电子琴',
        title: 'PSS-A50',
        artist: '',
        detail: [
            { img: '2-18.jpg' },
            { p: '•42种音色•138种琶音<br/>•动态效果<br/>•滑音<br/>•乐句录音<br/>•力度反馈功能<br/>•USB-MIDI' }
        ],
        link:''
    },
    {
        id: 19,
        category:'ekb',
        subtitle: '双排键',
        title: 'ELC-02',
        artist: '',
        detail: [
            { img: '2-19.jpg' },
            { p: '•便携式设计 <br/>•986种高品质音色 <br/>•634种高品质伴奏型 <br/>•506种注册菜单 <br/>•带触后的FS键盘 <br/>•第二表情踏板 <br/>•专用音箱 <br/>•音频录音 <br/>•全彩触屏' }
        ],
        link:'https://www.yamaha.com.cn/products/show/1688'
    },
    //管乐
    {
        id: 1,
        category:'wind',
        subtitle: '长笛',
        title: 'YFL-897H',
        artist: '',
        detail: [
            { img: '3-1.jpg' },
            { p: '银制Ideal系列长笛为实现声音的平衡采用了新型退火工艺，充分发挥银本身音质的加工技术以及出色的重量平衡，从管体和按键每一个细小的部件都用心打磨，以达到整体协调一致的效果。焊接式音孔采用厚壁设计以及适度削薄加工工艺，使演奏出的声音不仅丰富多彩、有力量感，而且具有宽广的音域，各种强弱音都表现出色是它的绝对魅力。<br/>（图为YFL-897）' }
        ],
        link:'https://www.yamaha.com.cn/products/show/152'
    },
    {
        id: 2,
        category:'wind',
        subtitle: '小号',
        title: 'Xeno Artist系列',
        artist: '',
        detail: [
            { img: '3-2.jpg' },
            { p: 'Xeno  Artist系列小号深受世界众多管弦乐团演奏者的欢迎。最新型号进一步提升了产品魅力，兼具优雅的表现力和吹奏性。我们研究了被认为是杰作的经典小号，根据研究结果改良了活塞筒并采用了新的软木塞材料。全新的规格提升了乐器的基本性能，包括更强的反应力和清晰、细腻的音粒质感。' }
        ],
        link:''
    },
    {
        id: 3,
        category:'wind',
        subtitle: '小号',
        title: 'YTR-8340EM',
        artist: '',
        detail: [
            { img: '3-3.jpg' },
            { p: '与日本知名小号演奏家Eric  Miyashiro合作研发设计。从三层环形指环设计、采用法式拱形卷边法工艺的大喇叭口、喇叭管侧面连接加工、定制型吹嘴到半硬质地的双肩背乐器盒，该乐器充分体现了雅马哈对每一处细节的关注。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/235'
    },
    {
        id: 4,
        category:'wind',
        subtitle: '单簧管',
        title: 'YCL-SEARTISTMODEL',
        artist: '',
        detail: [
            { img: '3-4.jpg' },
            { p: 'SE  ArtistModel是SE系列的集大成之作，这一型号最大限度地发挥了雅马哈单簧管所具备的潜能，融合新技术与工匠们的传统手工艺制作而成。作为乐器心脏部分的主管及音孔规格焕然一新，音准更加出色，低音到高音的吹奏阻力和吹奏感均能保持一致，同时实现了有深度的鸣响。经过深入考量的构造设计更能满足演奏者将全部注意力集中于演奏本身的需求。' }
        ],
        link:''
    },
    {
        id: 5,
        category:'wind',
        subtitle: '萨克斯',
        title: 'YAS-875EX',
        artist: '',
        detail: [
            { img: '3-5.jpg' },
            { p: '该乐器音色丰富优质且充满威严感，具有舒适流畅的按键操作和出色的低音发音性。性能进一步升级的定制型EX型号帮助演奏者自由地表达。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/195'
    },
    {
        id: 6,
        category:'wind',
        subtitle: '长号',
        title: 'YSL-8820R',
        artist: '',
        detail: [
            { img: '3-6.jpg' },
            { p: '与伊斯特曼音乐学院教授Larry  Zalkind共同研发设计，以交响曲式的音质和吹奏感的平衡为主题的一款乐器。反套式主管和F管调音管，全新设计的拉管支撑、新构造的转阀、采用高级镍银制成的宽拉管、交换式的吹口管等多处采用了革新的规格设计。' }
        ],
        link:''
    },
    {
        id: 7,
        category:'wind',
        subtitle: '圆号',
        title: 'YHR-891',
        artist: '',
        detail: [
            { img: '3-7.jpg' },
            { p: '这款乐器实现了3种调性管体全部协调一致的高度平衡。无论是管弦乐队演奏、室内独奏，还是巴洛克风格的音乐，以所有乐曲的全能演奏为奋斗目标的职业圆号手的梦想，在此得以实现。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/310'
    },
    {
        id: 8,
        category:'wind',
        subtitle: '新风管',
        title: 'Venova系列',
        artist: '',
        detail: [
            { img: '3-8.jpg' },
            { p: '轻松上手，且能够享受专业演奏的新型管乐器Venova。<br />轻松上手：<br />设计轻便小巧、便于随身携带。<br />可水洗，易于日常清洁。<br />吹奏指法类似竖笛，操作简单。<br />专业的声音：<br />拥有如萨克斯管般表现力丰富的音色以及专业的吹奏感。<br />结构简洁，但可实现2个八度音域。<br /><br />高音Venova YVS-100：C调（2个八度）<br />中音Venova YVS-120：F调（2个八度）' }
        ],
        link:'https://www.yamaha.com.cn/products/show/1679'
    },
    //吉他
    {
        id: 1,
        category:'guitar',
        subtitle: '民谣吉他 L系列',
        title: 'LL36//ARE',
        artist: '',
        detail: [
            { img: '4-1.jpg' },
            { p: '雅马哈 LL  系列以可以制造出气势磅礴的音量动态、清晰的共鸣、宽广的动态范围而闻名世界。在加入了 LL23/LL36日产型号之后，LL  系列再次在世界范围内，成为受到专业演奏欢迎的系列。华丽的装饰下，每个型号都由经验丰富的手工艺亲手制作而成。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/603'
    },
    {
        id: 2,
        category:'guitar',
        subtitle: '民谣吉他 L系列',
        title: 'LS26//ARE',
        artist: '',
        detail: [
            { img: '4-2.jpg' },
            { p: '雅马哈 LS 系列琴型已经有很长历史了。经过重新设计的琴颈结构，赋予了该系列更强的演奏性。新的音梁架构及雅马哈独创的  A.R.E. 技术，让该系列小琴体能产生出巨大音量。平衡的音色和优美的共鸣性特别适合于指弹演奏，同时还原指弹时的所有细节之处。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/608'
    },
    {
        id: 3,
        category:'guitar',
        subtitle: '民谣吉他 L系列',
        title: 'LJ26//ARE',
        artist: '',
        detail: [
            { img: '4-3.jpg' },
            { p: '中型 JUMBO 琴型 LJ  系列吉他的设计目的为稳固和舒适地放置在腿上弹奏。它低频突出、动态范围宽广，带有出色共鸣的清晰音色。同时应用了  A.R.E（原声共鸣加强）技术及新型的音梁架构，带来更为震撼的低频和更清晰的中频表现。这使得 LJ 系列成为了一款全能吉他，无论扫弦还是领奏都能轻松应对。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/594'
    },
    {
        id: 4,
        category:'guitar',
        subtitle: '古典吉他 GC系列',
        title: 'GC42S',
        artist: '',
        detail: [
            { img: '4-4.jpg' },
            { p: '西班牙传统的古典吉他制作技术与雅马哈技术研究的完美结合。全单的GC42S采用了欧洲云杉面板搭配玫瑰木背侧的组合，云杉的温暖和对中高频的响应可以带来纯正的古典吉他声音' }
        ],
        link:'https://www.yamaha.com.cn/products/show/1504'
    },
    {
        id: 5,
        category:'guitar',
        subtitle: '古典吉他 GC系列',
        title: 'GC42C',
        artist: '',
        detail: [
            { img: '4-5.jpg' },
            { p: '西班牙传统的古典吉他制作技术与雅马哈技术研究的完美结合。全单的GC42C采用了美洲红松面板搭配玫瑰木背侧的组合，可获得更加温暖醇厚的古典吉他音色' }
        ],
        link:'https://www.yamaha.com.cn/products/show/1503'
    },
    {
        id: 6,
        category:'guitar',
        subtitle: '民谣吉他 FG红标系列',
        title: 'FGX5/FSX5/FG5',
        artist: '',
        detail: [
            { img: '4-6.jpg' },
            { p: '雅马哈FG红标系列吉他在2019年一经上市，便获得了广泛的认可，其经典复古的外观搭配高科技的拾音器为原声吉他界树立了新的标杆。其中带"X"的型号表示搭载了雅马哈新研发的高科技拾音器“Atmosfeel”全景声拾音器。<br/>・FG琴型也沿袭了雅马哈初代型号FG180的经典琴型。<br/>・FS小箱体琴型沿袭了雅马哈初代吉他FG150的琴身设计。' }
        ],
        link:'https://www.yamaha.com.cn/products/musical-instruments/guitars/acousticguitar/folkguitar/fg_redlabel'
    },
    {
        id: 7,
        category:'guitar',
        subtitle: '民谣吉他 A系列',
        title: 'A5R ARE/AC5R ARE',
        artist: '',
        detail: [
            { img: '4-7.jpg' },
            { p: '日产A5R  A.R.E.使用传统西部缺角箱体，单板玫瑰木背板和侧板以及精心挑选并经过A.R.E.原声共鸣加强技术处理的单板锡加云杉木面板。SRT2拾音系统能将吉他自然又动态丰富的音色呈现在舞台上和录音棚中。' }
        ],
        link:'https://www.yamaha.com.cn/products/musical-instruments/guitars/acousticguitar/folkguitar/a-series/'
    },
    {
        id: 8,
        category:'guitar',
        subtitle: '加振吉他',
        title: 'LL-TA/FS-TA/CSF-TA/CG-TA',
        artist: '',
        detail: [
            { img: '4-8.jpg' },
            { p: '没有什么比的上在一个拥有美妙音效的房间中演奏吉他来的开心的事了！好的演奏场景可以使您的吉他音色更加完美，让您感觉弹得更棒、让您涌现出更多的演奏灵感。现在全新的雅马哈TransAcoustic™加振吉他将重现给您最棒的弹奏经验，无须外接音箱、无须外接效果器、只靠吉他本身，给你全新的演奏体验。' }
        ],
        link:'https://www.yamaha.com.cn/products/musical-instruments/guitars/acousticguitar/folkguitar/TransAcousticGuitars'
    },
    {
        id: 9,
        category:'guitar',
        subtitle: '静音吉他',
        title: 'SLG200NW',
        artist: '',
        detail: [
            { img: '4-9.jpg' },
            { p: 'SLG200 系列分为三种不同的型号，其中 SLG200NW  则是完全采用了古典吉他的设计规格，其52mm的标准指板宽度让古典吉他手可以迅速上手。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/1662'
    },
    {
        id: 10,
        category:'guitar',
        subtitle: '静音吉他',
        title: 'SLG200N',
        artist: '',
        detail: [
            { img: '4-10.jpg' },
            { p: 'SLG200 系列分为三种不同的型号，其中 SLG200S 的琴颈形状及 634mm  的弦长，承袭了常规原声吉他的设计传统，而其极细的琴身能够同时成为原声吉他和电吉他吉他手的选择。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/1406'
    },
    {
        id: 11,
        category:'guitar',
        subtitle: '静音吉他',
        title: 'SLG200S',
        artist: '',
        detail: [
            { img: '4-11.jpg' },
            { p: 'SLG200 系列分为三种不同的型号，其中SLG200N 的琴颈较薄，提供了演奏家更大的发挥余地，让平时不经常演奏古典吉他的演奏者也能轻松上手 ' }
        ],
        link:'https://www.yamaha.com.cn/products/show/1408'
    },
    {
        id: 12,
        category:'guitar',
        subtitle: '电吉他 Pacifica系列',
        title: 'PACIFICA612VIIFM',
        artist: '',
        detail: [
            { img: '4-12.jpg' },
            { p: '限量版的pac612viifm拥有专业的硬件和拾音器设备，坚固的枫木桤木琴体表现了它不妥协的本质。来自Seymour  Duncan的单单双拾音器和Wilkinson VS50琴桥标志着这把高性能吉他将获得非凡的荣耀。' }
        ],
        link:''
    },
    {
        id: 13,
        category:'guitar',
        subtitle: '电吉他 Pacifica系列',
        title: 'RSP20CR',
        artist: '',
        detail: [
            { img: '4-13.jpg' },
            { p: '受到20世纪60年代风靡街头的Café  Racer摩托车启发，Revstar全力秉承简介复古的外观和高性能表现的设计理念。精选的材料和部件通过手工打造将他们融合到一起，使之拥有独特的外观。旗舰型RSP20CR采用三拼桃花芯木琴颈和枫木和桃花芯木琴体，搭配的双线圈拾音器/Alnico  V磁石和铜制护板，处处体现日产的精湛工艺。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/1731'
    },
    {
        id: 14,
        category:'guitar',
        subtitle: '电吉他 Pacifica系列',
        title: 'RS720B',
        artist: '',
        detail: [
            { img: '4-14.jpg' },
            { p: 'RS720B不论是风格、手感、音色都毫无疑问的是经典样式，但却没有任何一样细节是盲从于传统：从完全独特、完美搭配Bigsby经典摇座的拾音器音色，到重现Yamaha经典吉他款式的镶嵌与美丽的手制漆面。他注定会成为全新的经典。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/1729'
    },
    {
        id: 15,
        category:'guitar',
        subtitle: '电吉他 Pacifica系列',
        title: 'RS720BX',
        artist: '',
        detail: [
            { img: '4-15.jpg' },
            { p: 'RS720BX不论是风格、手感、音色都毫无疑问的是经典样式。定制双线圈拾音器，Bigsby的颤音摇把的灵感均来自我们1970年代的“Super  Fighter”系列。重现的Yamaha经典吉他款式的镶嵌与美丽的手制漆面使它注定会成为全新的经典。' }
        ],
        link:''
    },
    {
        id: 16,
        category:'guitar',
        subtitle: '电吉他 Pacifica系列',
        title: 'RS502T',
        artist: '',
        detail: [
            { img: '4-16.jpg' },
            { p: 'RS502T呈现Revstar原本的设计概念：特制的琴身配件、独特的Revstar造型、令人惊艳的音色，设计出经典与独特的平衡点。RS502T正是你心中希望的那把吉他。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/1727'
    },
    {
        id: 17,
        category:'guitar',
        subtitle: '电贝司 TRBX系列',
        title: 'TRBX604FM',
        artist: '',
        detail: [
            { img: '4-17.jpg' },
            { p: '火焰枫木表面的TRBX600系列是为了您追求的完美音色所生。精细制作的桃花心木琴体和主动/被动拾音器切换提供了灵活的操控性和纯粹的完美音质让您尽情享受您的音乐。' }
        ],
        link:''
    },
    {
        id: 18,
        category:'guitar',
        subtitle: '电贝司 TRBX系列',
        title: 'TRBX605FM',
        artist: '',
        detail: [
            { img: '4-18.jpg' },
            { p: 'TRBX605是TRBX604的5弦版本，精细制作的桃花心木琴体和主动/被动拾音器切换提供了灵活的操控性和纯粹的完美音质让您尽情享受您的音乐。' }
        ],
        link:''
    },
    {
        id: 19,
        category:'guitar',
        subtitle: '电贝司 BB系列',
        title: 'BBP35',
        artist: '',
        detail: [
            { img: '4-19.jpg' },
            { p: '日本制造的旗舰款BB贝斯，具有雅马哈独特的I.R.A.技术，六螺栓斜接琴颈与琴体，可使用穿体或传统方式固定琴弦的琴桥，桤木/枫木/桤木三拼琴体结构。拾音器采用了YGD 定制的 V7拾音器，可提供彭拜而宽广的声音输出' }
        ],
        link:'https://www.yamaha.com.cn/products/show/1736'
    },
    {
        id: 20,
        category:'guitar',
        subtitle: '电贝司 BB系列',
        title: 'BB734A',
        artist: '',
        detail: [
            { img: '4-20.jpg' },
            { p: 'BB700系列采用三段可调EQ,六螺栓斜街琴颈与琴身，桤木/枫木/桤木层压琴体结构，以及可使用穿体或传统方式固定琴弦的琴桥，提供多功能主动/被动拾音器配置。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/1737'
    },
    {
        id: 21,
        category:'guitar',
        subtitle: '原声鼓',
        title: 'Live Custom  Hybrid Oak',
        artist: '',
        detail: [
            { img: '4-21.jpg' },
            { p: '雅马哈通过强调音头的反射，扩大了新Live Custom鼓组的动态范围。<br/>新的7层橡木/酚醛树脂混合型鼓腔和低音增强负重，展现强大的力量和声音，特别适合于现场演奏。此外，利用传统日本「浮造（UZUKURI）」工艺的新表面技术，强化橡木纹的自然之美。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/2261'
    },
    {
        id: 22,
        category:'guitar',
        subtitle: '电子鼓 DTX900系列',
        title: 'DTX920K',
        artist: '',
        detail: [
            { img: '4-22.jpg' },
            { p: '被誉为节奏的DTX-PAD，高品质音源DTX900，<br/>真实镲片和耐久底鼓打击板，<br/>这一切构成了雅马哈革命性的套鼓——旗舰电子套鼓DTX900系列。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/696'
    },
    {
        id: 23,
        category:'guitar',
        subtitle: '电子鼓 DTX502系列',
        title: 'DTX582K',
        artist: '',
        detail: [
            { img: '4-23.jpg' },
            { p: 'DTX582K配备小鼓、中鼓与落地鼓，适用的所有 DTX-PAD 打击板，以及即时脚踏鈸与三区铜鈸，让您表现杰出鼓技。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/692'
    },
    {
        id: 24,
        category:'guitar',
        subtitle: '合成器 MONTAGE系列',
        title: 'MONTAGE8 WH',
        artist: '',
        detail: [
            { img: '4-24.jpg' },
            { p: '雅马哈MONTAGE系列键盘功能强大，以其精密的动态控制、强大的声音创作功能和流畅的工作流程，为合成器树立了下一个新的里程碑。如今，我们为您荣幸带来了白色版本的MONTAGE，全新颜色的加入将更加有利于激发您的创作灵感。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/1634'
    },
    {
        id: 25,
        category:'guitar',
        subtitle: '合成器 MONTAGE系列',
        title: 'MONTAGE7 WH',
        artist: '',
        detail: [
            { img: '4-25.jpg' },
            { p: '雅马哈MONTAGE系列键盘功能强大，以其精密的动态控制、强大的声音创作功能和流畅的工作流程，为合成器树立了下一个新的里程碑。如今，我们为您荣幸带来了白色版本的MONTAGE，全新颜色的加入将更加有利于激发您的创作灵感。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/1633'
    },
    {
        id: 26,
        category:'guitar',
        subtitle: '合成器 MONTAGE系列',
        title: 'MONTAGE6 WH',
        artist: '',
        detail: [
            { img: '4-26.jpg' },
            { p: '雅马哈MONTAGE系列键盘功能强大，以其精密的动态控制、强大的声音创作功能和流畅的工作流程，为合成器树立了下一个新的里程碑。如今，我们为您荣幸带来了白色版本的MONTAGE，全新颜色的加入将更加有利于激发您的创作灵感。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/1632'
    },
    {
        id: 27,
        category:'guitar',
        subtitle: '合成器 MODX系列',
        title: 'MODX7/MODX8',
        artist: '',
        detail: [
            { img: '4-27.jpg' },
            { p: '音色是乐器的核心，MODX合成引擎的强大功能可以满足艺术家所需的独特音色。MODX的音色引擎与旗舰合成器MONTAGE使用同样的技术：AWM2+FM-X。实现令人惊叹的音色和复杂音色创造。' }
        ],
        link:'https://www.yamaha.com.cn/products/music-production/synthesizer/modx_series/'
    },
    {
        id: 28,
        category:'guitar',
        subtitle: '舞台钢琴 CP系列',
        title: 'CP88/CP73',
        artist: '',
        detail: [
            { img: '4-28.jpg' },
            { p: '新的CP 舞台钢琴在2019年上市，它融合 100 多年的制琴工艺和 45  年的合成器创新技术，展现真实的原声和电子钢琴音色、逼真的钢琴触感和直观的使用者界面。其中的CP88采用了天然实木制造的三传感器配重键盘，可获得如演奏真实钢琴一般的触感。CP73采用了BHS平衡式标准键盘，更假注重轻量化和可移动性。' }
        ],
        link:'https://www.yamaha.com.cn/products/music-production/stagepiano/cp8873_series/'
    },
    //家庭音响

    {
        id: 2,
        category:'av',
        subtitle: '书架音箱',
        title: 'NS-5000',
        artist: '',
        detail: [
            { img: '5-2.jpg' },
            { p: '雅马哈推出3分频旗舰书架音箱,  呈现给您Hi-Fi扬声器质量和表现力的新标准。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/1599'
    },
    {
        id: 3,
        category:'av',
        subtitle: '音箱支架',
        title: 'SPS-5000',
        artist: '',
        detail: [
            { img: '5-3.jpg' },
            { p: '专为NS-5000设计的音箱支架，由实心铝制成，追求稳定适宜的声音。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/1600'
    },
    {
        id: 4,
        category:'av',
        subtitle: 'HiFi功放',
        title: 'M-5000',
        artist: '',
        detail: [
            { img: '5-4.jpg' },
            { p: '拥有130多年的经验，雅马哈已成长为世界熟知的音响公司。M-5000体现了历史悠久的工艺和市场领先的创新精神，并作为高保真音频复制的缩影。<br/>•200W+200W(4ohm,20Hz-20kHz,0.07%THD,2-ch driven)<br/>•100W+100W(8ohm,20Hz-20kHz,0.07%THD,2-ch driven)<br/>•精心设计的平衡信号传输<br/>•浮动和平衡的功率放大器布局，更改善其驾驭性<br/>•对称设计，以隔离左右声道<br/>•采用短信号和电源供应路径的低阻抗设计<br/>•改良的结构设计，实现刚性耐用。<br/>•大型环形铁心电源变压器' }
        ],
        link:'https://www.yamaha.com.cn/products/show/2239'
    },
    {
        id: 5,
        category:'av',
        subtitle: 'HiFi功放',
        title: 'C-5000',
        artist: '',
        detail: [
            { img: '5-5.jpg' },
            { p: '为了追求无形的音乐品质，为高保真音响注入新生命，全新推出了C-5000  前置放大器。从演奏会舞台到您的家中，雅马哈凭借着其丰富的舞台和家庭音乐体验，能忠实重现出音乐表演中的每个细节与情感。' }
        ],
        link:'https://www.yamaha.com.cn/products/show/2230'
    },

]